import { ArrowIcon } from "../icons";
import { IconButton } from "@/components";
import clsx from "clsx";
import { PaginationTypeProps } from "@/components/data-table/types/pagination-type-props";
import { isDefined } from "@/helper/utils";

export const PaginationDot = ({
  goPrev,
  disablePrev,
  listPage,
  onChangePage,
  currentPage,
  goNext,
  disableNext,
  className,
  showControl,
}: PaginationTypeProps) => {
  return (
    <div className={clsx("pagination flex justify-between mt-2.5", className)}>
      {showControl && (
        <IconButton
          onClick={goPrev}
          disabled={disablePrev}
          className={clsx(disablePrev && "pointer-events-none cursor-not-allowed opacity-30")}
        >
          <ArrowIcon />
        </IconButton>
      )}
      <div className="flex gap-[16.39px] items-center">
        {listPage.map(({ page, optional }, index) => {
          const nodeKey = listPage[index - 1]?.page + "-" + index;
          return isDefined(page) ? (
            <IconButton
              key={`pagination-dot-${nodeKey}`}
              className={clsx(
                optional ? "hidden lg:inline-flex" : "inline-flex",
                page === currentPage ? "bg-pagination-active" : "bg-pagination opacity-[0.34]",
                "w-[8.5px] h-[8.5px] cursor-pointer rounded-full",
              )}
              onClick={() => onChangePage(page)}
            />
          ) : (
            <span
              className="-ml-px relative rounded-lg inline-flex items-center text-sm leading-5 font-bold"
              key={`filler-${nodeKey}`}
            >
              ...
            </span>
          );
        })}
      </div>
      {showControl && (
        <IconButton
          onClick={goNext}
          disabled={disableNext}
          className={clsx(disableNext && "pointer-events-none cursor-not-allowed opacity-30")}
        >
          <ArrowIcon className="rotate-180" />
        </IconButton>
      )}
    </div>
  );
};
